import { ConcreteEncodable } from "./ConcreteEncodable";

import { FixingStatusResponseImplEncoder } from "../../encoder/FixingStatusResponseImplEncoder";

import * as CubiqTS from "../../index";
import { FixingStatusResponse } from "../FixingStatusResponse";

export class FixingStatusResponseImpl extends ConcreteEncodable implements FixingStatusResponse {
  public static enType: string = "com.bcdfx.model.FixingStatusResponseImpl";

  /*FID=1*/
  public fixingPositionStatus: Array<CubiqTS.FixingPositionStatus> | null = null;
  /*FID=2*/
  public fixingEvent: Array<CubiqTS.FixingEvent> | null = null;
  /*FID=3*/
  public manualHedgingPositions: Array<CubiqTS.ChangeHedgingModeEvent> | null = null;
  /*FID=4*/
  public benchmarkPositionAudits: Array<CubiqTS.BenchmarkPositionAudit> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = FixingStatusResponseImplEncoder.Instance;
    this.setEncodableType(FixingStatusResponseImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "FixingStatusResponseImpl[" +
      "fixingPositionStatus=" +
      this.fixingPositionStatus +
      "fixingEvent=" +
      this.fixingEvent +
      "manualHedgingPositions=" +
      this.manualHedgingPositions +
      "benchmarkPositionAudits=" +
      this.benchmarkPositionAudits +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
